// import { init_app_state } from "./app.reducer";

export const get_schedule_api_status = (state) => {
  const {
    app:
    {
      output:
      {
        status: {
          loading,
          success,
          failure,
          error_message,
          download_progress,
          upload_progress
        }
      },
    }
  }
    = state;
  return {
    loading,
    success,
    failure,
    error_message,
    download_progress,
    upload_progress
  };
};

export const get_output_views = (state) => {
  const { app } = state;
  const { output: {
    analyst_view,
    machine_view,
    product_view,
    sla_metrics
  } } = app;
  return {
    analyst_view,
    machine_view,
    product_view,
    sla_metrics
  };
};